import { createSelector } from 'reselect';
import { Map as IMap } from 'immutable';
import { getLoyaltyNumber as getAuthLoyaltyNumber, getIsAuthenticated } from '../auth/authSelectors';

export const getLoyalty = state => state.get('loyalty', IMap());




export const getLoyaltyNumber = createSelector(
    getLoyalty,
    getAuthLoyaltyNumber,
    (loyalty, authLoyaltyNumber) => loyalty.get('loyaltyNumber', '') || authLoyaltyNumber || ''
);



export const getSsoLoyaltyId = createSelector(
    getIsAuthenticated,
    getLoyaltyNumber,
    (isAuthenticated, loyaltyNumber) => (isAuthenticated && loyaltyNumber ? loyaltyNumber : null)
);
